<span class="ckb-container" (click)="clickHandler($event)" [ngClass]="cssClass" [ngStyle]="cssStyle">
    <i class="fa fa-square-o ckb-icon" [ngClass]="{'fa-square-o ckb-uncheck':!value,'fa-check-square ckb-check':value}"></i>
    <label class="ckb-text" *ngIf="text">{{text}}</label>
    <label class="ckb-content"><ng-content></ng-content></label>
</span>